import { render, staticRenderFns } from "./FuzzySearch.vue?vue&type=template&id=2b8d3e84&scoped=true&"
import script from "./FuzzySearch.vue?vue&type=script&lang=ts&"
export * from "./FuzzySearch.vue?vue&type=script&lang=ts&"
import style0 from "./FuzzySearch.vue?vue&type=style&index=0&id=2b8d3e84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d3e84",
  null
  
)

export default component.exports